module.exports = __webpack_public_path__ + "img/about.472e3b41.jpg";